//**************************************************************
import { Component, OnInit }              from '@angular/core';
//**************************************************************
// Router
import { Router, ActivatedRoute }         from '@angular/router';
import { Observable, Subscription }       from 'rxjs';
//**************************************************************
import { firestorecontrol }               from "../../appfirestore/app.firestore"
//**************************************************************
// Field Definitions
import { faqcategory }                    from '../../appfirestore/app.fields';
import { faqdetail }                      from '../../appfirestore/app.fields';
//**************************************************************
@Component({
  selector: 'app-comfaq',
  templateUrl: './comfaq.component.html',
  styleUrls: ['./comfaq.component.css']
})
//**************************************************************
export class ComfaqComponent implements OnInit 
{
  //*******************************************************
  formheight: number = 0;
  //**************************************************************
  // Subscriptions
  subscriptionfaqcategory:  faqcategory[];

  subscriptionfaqdetail:            Subscription;
  subscriptionfaqdetailprofile:     faqdetail[];

  faqdocid: string;
  faqitem: string;
  faqitemcollection: string;
  faqstatus: boolean = true;    
  faqnew: boolean = true; 

  loginselectdesc       = null; 
  //**************************************************************
  constructor (
                private firestoredata: firestorecontrol,
                private _Activatedroute:ActivatedRoute
              ) 
    { 
      //**************************************************************
      // Get FAQ categories
      this.firestoredata.loadadminfaqcategory();

      this.firestoredata.getfaqcategory().subscribe
                          ( faqcategory => 
                               {
                                this.subscriptionfaqcategory = faqcategory;
                               }
                           )
      //**************************************************************
    }
  //**************************************************************
  ngOnInit(): void 
    {
        // Form Height
        this.formheight  =  Number(this._Activatedroute.snapshot.paramMap.get("formheight"));



    }
  //**************************************************************
  selectfaqtype( event: any )
    {
      //**************************************************************
      // Document Id 
      this.faqitem = event.itemData.id
      // Collection Id
      this.faqitemcollection = this.faqitem;
      //**************************************************************
      this.faqstatus = false;

      // Locate FAQ list
      this.firestoredata.loadfaqdocument( this.faqitem );

      // FAQ Details
      this.subscriptionfaqdetail = this.firestoredata.getfaqdocument().subscribe
        ( faqdocitems => 
         { 
            this.subscriptionfaqdetailprofile = faqdocitems; 
            //console.log( this.subscriptionfaqdetailprofile )
          }
        );   
     
    }
  //**************************************************************
  async initinsertfaqdoc( event: any )
    {
      //**************************************************************
      event.data.id           = this.faqitem;
      event.data.sortid       = this.faqitem;
     
      event.data.notestatus   = true;
      event.data.noteid       = 'TBC'

      this.faqnew             = true;
      //**************************************************************
    }
  //**************************************************************
  async insertfaqdoc( event: any )
    {
    

      if ( event.data.noteid == 'TBC')
        {
          let maxfaqid            = await this.firestoredata.getfaqdocmaxid( this.faqitem  )
         
          this.faqitemcollection  = maxfaqid.toString();
          event.data.noteid       = this.faqitemcollection;

          this.faqdocid           = this.faqitem + '-' + event.data.noteid;
        }
      else
        {
          this.faqdocid           = event.data.id
        }

      //console.log( this.faqdocid  )
      //console.log( this.faqitem)
      //console.log( this.faqitemcollection )

      // Update Data
      this.firestoredata.updatefaqnote( this.faqdocid, this.faqitem, this.faqitemcollection, event )
    }
  //**************************************************************
  editfaqdoc( event: any )
    {
      //console.log( event )
      this.faqitemcollection  = event.data.sortid;
      this.faqdocid           = event.data.sortid + '-' + event.data.noteid;
      this.faqnew             = false;
    }
  //**************************************************************
}
